export default [
  { value: 'activate', label: 'Activate' },
  { value: 'deactivate', label: 'Deactivate' },
];
